import { withInstall } from "../utils/index.mjs";
import _TabbarItem from "./TabbarItem.mjs";
const TabbarItem = withInstall(_TabbarItem);
var stdin_default = TabbarItem;
import { tabbarItemProps } from "./TabbarItem.mjs";
export {
  TabbarItem,
  stdin_default as default,
  tabbarItemProps
};
